<template>
  <div>
    <h4 class="tw-text-2xl tw-mb-3 opacity-54">Links Resources</h4>
    <BaseCard class="tw-flex tw-flex-no-wrap tw-py-2 tw-px-4 tw-items-center tw-border-t-2 tw-border-app-white-87 tw-transition-slow">
      <div class="tw-inline-flex tw-items-center">
        <!--  -->
        <svg version="1.1" class="tw-w-6 tw-h-6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
          <path d="M32.2,72c-0.7,0-1.6-0.2-2.3-0.7c-1.1-0.7-1.8-2.1-1.8-3.4V43.7L7.8,5.7C7.2,4.3,7.4,3,8.1,1.8C8.7,0.7,9.9,0,11.5,0h49
            c1.4,0,2.7,0.7,3.4,1.8s0.9,2.5,0.5,3.9L45.7,43.7v17.8c0,1.6-0.9,3-2.3,3.6l-9.6,6.4C33.4,71.8,32.7,72,32.2,72z M12.2,4.6
            l20.1,37.4c0.2,0.7,0.5,1.1,0.5,1.8V67l8.4-5.7V43.5c0-0.5,0-1.1,0.2-1.6L59.6,4.3H12.2V4.6z"/>
        </svg>
        <p class="leading-19 tw-ml-2">Filter</p>
      </div>
      <BaseInput
        v-model="filterConfig.search"
        type="text"
        placeholder="Search by name of the resource"
        input-class="tw-ml-8 tw-bg-app-deep-blue-11 tw-rounded-3 tw-text-sm leading-17 tw-p-2 tw-flex-grow tw-min-w-1/4"
      />
    </BaseCard>

    <!-- LINKS -->
    <transition name="fade" mode="out-in" appear>

      <div v-if="errorResources" class="tw-mt-12">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorResources"></p>
      </div>

      <ContentLoadingThreeGrid
        v-else-if="loadingResources"
        class="tw-mt-16 -tw-max-w-list tw-mx-auto"
      />

      <template v-else>

        <div v-if="filteredList.length === 0 && hasFiltered" class="tw-mt-12">
          <!-- Goodies -->
          <p class="tw-py-16 tw-text-base tw-text-center opacity-54">Resource not found</p>
        </div>

        <div v-else-if="filteredList.length === 0" class="tw-mt-12">
          <!-- Goodies -->
          <p class="tw-py-16 tw-text-base tw-text-center opacity-54">There are 0 link resources</p>
        </div>

        <ViewMore
          v-else
          class="tw-flex tw-flex-wrap stacked-grid lg:stacked-grid--stack-three stacked-grid--stack-three tw-mt-12"
          :list="filteredList"
          :limit="6"
        >

          <template v-slot="{ item: resource, index }">
            <LinkResourceCard
              :key="`res-${index}`"
              :resource="resourceCardData(resource)"
              @click-delete="(...args) => deleteResource(...args)"
            >
              <template v-slot:default v-if="resource.company && isSuperAdmin">
                <div v-if="resource.company" class="tw-my-1 tw-p-2 tw-bg-app-black-11">
                  <p class="tw-text-xs opacity-54 leading-15 tw-uppercase tw-font-bold">
                    Company
                  </p>
                  <p class="tw-text-sm leading-15">
                    {{ resource.company.company }}
                  </p>
                </div>

              </template>
            </LinkResourceCard>
          </template>

        </ViewMore>

      </template>

    </transition>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import ContentLoadingThreeGrid from '@/components/ContentLoadingThreeGrid.vue';
import LinkResourceCard from '@/components/LinkResourceCard.vue';

import filterMixin from '@/mixins/filter';

import _uniqBy from 'lodash/uniqBy';
import _groupBy from 'lodash/groupBy';
import _reverse from 'lodash/reverse';
import _sortBy from 'lodash/sortBy';

export default {
  name: 'LinksResources',
  mixins: [filterMixin],
  components: {
    BaseInput,
    ContentLoadingThreeGrid,
    LinkResourceCard,
  },
  props: {
    propToTriggerGetResources: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resources: [],
      resourcesShares: {},
      resourcesCompanies: {},
      resourcesSenders: {},
      loadingResources: true,
      errorResources: undefined,
      filterConfig: {
        search: '',
        searchAt: [
          'link',
          'title',
          'name',
        ],
        dataName: 'resources',
      },
    };
  },
  watch: {
    propToTriggerGetResources(newVal, oldVal) {
      if (newVal !== oldVal) {
        // get resources
        this.getResources();
      }
    },
  },
  computed: {
    hasFiltered() {
      return this.filterConfig.search.length > 0;
    },
    canFetchResources() {
      return !!this.$store.getters.resourcesContextId && !!this.$store.getters.resourcesProgramContextId && !!this.$store.getters.resourcesProgramContextTypeId;
    },
  },
  methods: {
    async getResources() {
      if (!this.canFetchResources) return false;

      this.loadingResources = true;
      this.errorResources = undefined;
      await this.$nextTick();
      //

      const resources = await this.$store.dispatch('getLinkResources');

      // if (this.isRegionalAdmin) {
      //   resources = await this.$store.dispatch('getLinkResourcesInRegion');
      // } else {
      //   resources = await this.$store.dispatch('getLinkResources');
      // }

      if (!resources) {
        this.$toasted.global.appError();
        await this.$nextTick();
        this.loadingResources = false;
        this.errorResources = 'We could not get shared resources. Please try again later';

        return false;
      }

      // const getResourceUniqId = (resource) => {
      //   // ? how to
      // };

      const sendersPromises = [];
      const companiesPromises = [];
      const uniqGroupedResources = _groupBy(resources, 'resourceid');

      resources.forEach((res) => {
        // count number of shares
        const key = res.resourceid;
        if (!this.resourcesShares[key]) {
          const shares = _uniqBy(uniqGroupedResources[key], 'userid').length;
          this.resourcesShares[key] = shares;
        }

        if (!this.resourcesSenders[res.senderid]) {
          sendersPromises.push(this.$store.dispatch('getUserData', res.senderid));
          this.resourcesSenders[res.senderid] = { id: res.senderid };
        }

        if (!this.resourcesCompanies[res.companyid] && this.isSuperAdmin) {
          companiesPromises.push(this.$store.dispatch('getCompany', [res.companyid]));
          this.resourcesCompanies[res.companyid] = { id: res.companyid };
        }
      });

      Promise.all(sendersPromises).then((resolvedSenders) => {
        resolvedSenders.forEach((sender) => {
          this.resourcesSenders[sender.id] = sender;
        });
      });

      if (this.isSuperAdmin) {
        Promise.all(companiesPromises).then((resolvedCompanies) => {
          resolvedCompanies.forEach((company) => {
            this.resourcesCompanies[company.id] = company;
          });
        });
      }

      await Promise.all([...sendersPromises, ...companiesPromises]);

      const promises = [];
      const uniqResources = _uniqBy(resources, 'resourceid');

      uniqResources.forEach((resource) => {
        promises.push(this.$store.dispatch('getResource', [resource.resourceid, 2])); // 2 = link resource
      });

      Promise.all(promises).then((resolvedResources) => {
        const validResources = resolvedResources.filter((r) => !!r?.id);

        this.resources = _reverse(_sortBy(validResources, ['dateOfPost']));
      });

      // this.resources = _reverse(_sortBy(_uniqBy(resources, (r) => `${r.resource}/${r.type}`), ['dateOfPost']));

      await this.$nextTick();

      this.errorResources = undefined;
      this.loadingResources = false;

      return true;
    },
    resourceCardData(resource = {}) {
      const key = `${resource.id}`;

      return {
        ...resource,
        ...{
          shares: this.resourcesShares[key],
          sender: this.resourcesSenders[resource.senderid],
          company: this.isSuperAdmin ? this.resourcesCompanies[resource.companyid] : {},
        },
      };
    },
    async deleteResource(resource) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm(`Are you sure you want to delete "${resource.name || resource.title || resource.data}"?`);
      if (!confirm) return;

      const response = await this.$store.dispatch('deleteLinkResource', resource);

      if (!response) {
        this.$toasted.appError({ errorMessage: 'Sorry we can\'t delete resource at the moment' });
        return;
      }

      this.$toasted.success('Resource deleted', { duration: 4000 });
      this.getResources();

      this.$store.dispatch('logAction', this.$store.state.Logger.actionsIndexes.deleteLinkResources);
    },
  },
  async created() {
    // GET Resources
    await Promise.all([
      this.getResources(),
    ]);

    await this.$nextTick();
    await this.$nextTick();

    this.loadingResources = false;
  },
};
</script>

<style>

</style>
